import { render, staticRenderFns } from "./CRDPoolsDetail.vue?vue&type=template&id=10786f23&scoped=true&"
import script from "./CRDPoolsDetail.vue?vue&type=script&lang=js&"
export * from "./CRDPoolsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CRDPoolsDetail.vue?vue&type=style&index=0&id=10786f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10786f23",
  null
  
)

export default component.exports